"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Mixin = void 0;

var _style = require("./style");

var _font = require("./font");

var _device = require("./device");

var _screen = require("./screen");

var Mixin = {
  Style: _style.Style,
  Font: _font.Font,
  Device: _device.Device,
  Screen: _screen.Screen
};
exports.Mixin = Mixin;